// One vocabulary per declaration backend enum — both declaration forms read them, neither owns them.

// The server's `default_value_according_to_red_iii` enum — drives the GHG emission details branch.
export const GHG_DEFAULT_VALUE = Object.freeze({ yes: 'YES', no: 'NO' });

// Multisite transfer defaults to "No" — same Yes/No shape as GHG_DEFAULT_VALUE.
export const MULTISITE_TRANSFER_VALUE = Object.freeze({ yes: 'YES', no: 'NO' });

// The shared shape behind every plain Yes/No compliance dropdown in these forms.
export const YES_NO_VALUE = Object.freeze({ yes: 'YES', no: 'NO' });

// The server's `chain_of_custody_option` enum.
export const CHAIN_OF_CUSTODY_OPTION = Object.freeze({
  massBalance: 'MASS_BALANCE',
  physicalSegregation: 'PHYSICAL_SEGREGATION',
});

// The server's Esca bonus/cap enum.
export const ESCA_BONUS_CAP = Object.freeze({
  notClaimed: 'NOT_CLAIMED',
  manureBonus: 'MANURE_BONUS',
  noCapBefore2013: 'NO_CAP_BEFORE_2013',
  biofuelAfter2023: 'BIOFUEL_AFTER_2023',
  biocharUse: 'BIOCHAR_USE',
  priorEscaClaims: 'PRIOR_ESCA_CLAIMS',
});

// Dropdown-only values; OCR free text / legacy labels aren't real selections.
export const ESCA_BONUS_CAP_VALUES = Object.values(ESCA_BONUS_CAP);
export const isEscaBonusCapOption = (value) => ESCA_BONUS_CAP_VALUES.includes(value);
